import { Link } from 'react-router-dom';

const roles = [
  { icon: 'ri-exchange-line', text: 'Передача опыта от более опытного сотрудника менее опытному' },
  { icon: 'ri-tools-line', text: 'Помощь в освоении новых задач непосредственно в работе' },
  { icon: 'ri-search-eye-line', text: 'Разбор ошибок и сложных ситуаций' },
  { icon: 'ri-chat-check-line', text: 'Регулярная обратная связь по ходу работы' },
  { icon: 'ri-seedling-line', text: 'Развитие самостоятельности вместо готовых ответов' },
  { icon: 'ri-vip-crown-line', text: 'Подготовка сотрудников к новым ролям' },
];

export default function MentoringSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Наставничество как инструмент развития
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Часть развития происходит не в учебной аудитории, а в самой работе. Наставничество — это способ передавать опыт и закреплять навыки в реальных условиях.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {roles.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8 text-center">
          <p className="text-base text-gray-700 leading-relaxed mb-5 max-w-2xl mx-auto">
            Наставничество особенно полезно, когда сотруднику нужно освоить конкретную роль: новую должность, новые процессы или управленческую ответственность. Подробнее о том, как выстроить наставничество в компании, — на отдельной странице.
          </p>
          <Link
            to="/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
          >
            Наставничество и развитие сотрудников
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}